import { environment } from 'src/environments/environment';

export class Constants {
  static APP_TITLE = 'Obeikan Tutoring System';
  static APP_PLATFORM_TYPE = 'web';
  static AUTH_TOKEN = 'auth_token';
  static USER_REGISTER = 'user';
  static APP_LANGUAGE_COOKIE_KEY = 'appLang';
  static PAGE_SIZE = 20;
  static FILE_MAX_SIZE_IN_KB = 20000;
  static NOTIFICATION_CONFIG_TIME = 10000;
  static MOBILE_NUMBER_SEPARATOR = '-';
  static USER_DEVICE_KEY = 'UDK';
  static SNACK_BAR_DEFAULT_DURATION = 5000;
  static API_BASE_URL = environment.base_url + environment.api_prefix;
  static FIREBASE_API_URL = environment.firebase_url;
  static PACKAGE_API_URL(packageId: string): string {
    return `${environment.domain}?id=${packageId}&type=buyPackage`;
  }

  // login
  public static LOGIN_API_URL = this.API_BASE_URL + 'admin-login';

  // forget password
  public static FORGET_PASSWORD_API_URL = this.API_BASE_URL + 'admin-forget-password';

  // dashboard
  public static DASHBOARD_REPORTS_CHARTS_API_URL = this.API_BASE_URL + 'get-dashboard-reporting-chart';
  public static DASHBOARD_COUNT_OF_CURRENT_CALLS = this.API_BASE_URL + 'get-dashboard-current-calls';
  public static DASHBOARD_GET_BALANCE_REPORT_API_URL = this.API_BASE_URL + 'get-admin-student-pacakge-charts';
  public static DASHBOARD_GET_PEAK_TIME_REPORT_API_URL = this.API_BASE_URL + 'get-admin-peakTime-charts';
  public static DASHBOARD_CONTACT_US_MESSAGES_API_URL = this.API_BASE_URL + 'get-contactus-list';
  public static DASHBOARD_GET_CONTACT_US_MESSAGE_DETAILS = this.API_BASE_URL + 'get-list-replies-contactUs';
  public static DASHBOARD_SEND_REPLY_TO_MESSAGE_URL_API = this.API_BASE_URL + 'reply-contactus';
  public static APP_CONSUMPTION_API_URL = this.API_BASE_URL + 'app-consumption';

  // categories
  public static GET_CATEGORIES_API_URL = this.API_BASE_URL + 'get-categorise-with-teachers';
  public static GET_PAGINATED_CATEGORIES_API_URL = this.API_BASE_URL + 'paginate-categories';

  // reports
  public static GET_TEACHERS_REPORT_API_URL = this.API_BASE_URL + 'teacher-reports';
  public static GET_STUDENTS_REPORT_API_URL = this.API_BASE_URL + 'student-reports';
  public static GET_CALLS_REPORT_API_URL = this.API_BASE_URL + 'call-reports';
  public static GET_CALLS_DETAILS_REPORT_API_URL = this.API_BASE_URL + 'detailed-call-reports';
  public static GET_BLOCKED_STUDENTS_REPORT_API_URL = this.API_BASE_URL + 'get-teacher-blocked-students';
  public static GET_TEACHERS_PERFORMANCE_REPORT_API_URL = this.API_BASE_URL + 'teacher-performance-reports';
  public static GET_STUDENTS_PERFORMANCE_REPORT_API_URL = this.API_BASE_URL + 'student-performance-reports';
  public static GET_DEPENDENTS_REPORT_API_URL = this.API_BASE_URL + 'dependent-reports';
  public static GET_REVIEWS_REPORT_API_URL = this.API_BASE_URL + 'get-teacher-reviews';
  public static ADMIN_APPROVE_REVIEWS_URL = this.API_BASE_URL + 'admin-approve-reviews';
  public static ADMIN_HIDE_REVIEWS_URL = this.API_BASE_URL + 'admin-hide-student-review';
  public static UPDATE_TEACHER_REVIEW = this.API_BASE_URL + 'update-teacher-review';
  public static APPROVE_ADMIN_TEACHER_REVIEW_API_URL = this.API_BASE_URL + 'approve-admin-add-teacher-review';
  public static GET_BALANCE_REPORT = this.API_BASE_URL + 'student-pacakges-reports';
  public static MARK_PACKAGE_AS_CONSUMED_API_UEL = this.API_BASE_URL + 'admin-mark-package-consumed';
  public static CHANGE_PACKAGE_EXPIRATION_DATE = this.API_BASE_URL + 'admin-change-expiry-date';
  public static GET_SESSIONS_REPORT_API_URL = this.API_BASE_URL + 'get-students-sessions-details';
  public static GET_TEACHER_ONLINE_MINUTES_REPORT_API_URL = this.API_BASE_URL + 'get-teacher-online-minutes';
  public static GET_PEAK_HOURS_REPORT_API_URL = this.API_BASE_URL + 'peak-times-logger';
  public static GET_MESSAGES_REPORT_API_URL = this.API_BASE_URL + 'get-admin-notifications-report';
  public static GET_RESERVATIONS_REPORT_API_URL = this.API_BASE_URL + 'get-admin-reservations-report';
  public static GET_PAY_TABS_REPORT_API_URL = this.API_BASE_URL + 'get-student-payment-transactions';
  public static GET_SURVEYS_REPORT_API_URL = this.API_BASE_URL + 'admin-get-all-serveys';
  public static GET_STORE_RATINGS_REPORT_API_URL = this.API_BASE_URL + 'get-admin-mobile-app-ratings';
  public static GET_DONATIONS_REPORT_API_URL = this.API_BASE_URL + 'donations-report';
  public static GET_BENEFICARIES_REPORT_API_URL = this.API_BASE_URL + 'beneficiaries-donations-report';
  public static GET_STUDENTS_PLANS_REPORT_API_URL = this.API_BASE_URL + 'admin-get-students-plans';
  public static DELETE_STUDENTS_PLANS_REPORT_API_URL = this.API_BASE_URL + 'admin-delete-students-plans';
  public static GET_TOTAL_DURATION_REPORT_API_URL = this.API_BASE_URL + 'teacher-total-durations-reports';
  public static GET_TEACHERS_PLANS_REPORT_API_URL = this.API_BASE_URL + 'teacher-achievement-reports';
  public static GET_TEACHER_RESERVATION_REPORT_API_URL = this.API_BASE_URL + 'teacher-reservation-report';
  public static GET_FREE_CODE_CONSUMPTION_RATE_API_URL = this.API_BASE_URL + 'free-code-consumption-report';
  public static GET_FATIHA_SESSIONS_REPORT_API_URL = this.API_BASE_URL + 'fatiha/admin/sessions-report';
  public static EXPORT_FATIHA_REQUESTS_API_URL = this.API_BASE_URL + 'fatiha/admin/sessions-report-export';

  // update teacher info
  public static GET_TEACHERS_UPDATE_INFO_REQUESTS_API_URL =
    this.API_BASE_URL + 'admin-get-pending-teacher-edit-profile-requests';
  public static ADMIN_SUBMIT_ADMIN_PARTIAL_FEEDBACK_API_URL =
    this.API_BASE_URL + 'admin-response-teacher-edit-profile-request-partial';
  public static ADMIN_RESPONSE_FOR_TEACHER_REQUEST_API_URL =
    this.API_BASE_URL + 'admin-response-teacher-edit-profile-request';

  // Join Us Requests ( Students ):
  public static GET_ADMIN_JOINUS_REQUESTS_API_URL = this.API_BASE_URL + 'get-join-us';
  public static GET_ADMIN_ACCEPT_JOINUS_REQUESTS_API_URL = this.API_BASE_URL + 'approve-join-us-request';
  public static GET_ADMIN_REJECT_STUDENT_JOINUS_REQUESTS_API_URL = this.API_BASE_URL + 'reject-student-join-us-request';

  //teachers
  public static ADMIN_TEACHERS_API_URL = this.API_BASE_URL + 'admin-get-teachers';
  public static API_TEACHER_RESET_BALANCE_API_URL = this.API_BASE_URL + 'admin-reset-teacher-balance';
  public static API_TEACHER_OPTIONS_API_URL = this.API_BASE_URL + 'admin-update-teacher-options';
  public static API_TEACHER_GET_CATEGORIES_API_URL = this.API_BASE_URL + 'get-categorise-with-teachers';
  public static API_TEACHER_REMOVE_CATEGORIES_API_URL = this.API_BASE_URL + 'admin-remove-teacher-categories';
  public static API_TEACHER_UPDATE_CATEGORY_API_URL = this.API_BASE_URL + 'update-category-teacher';
  public static API_TEACHER_RESET_USER_PASSWORD_API_URL = this.API_BASE_URL + 'admin-reset-user-password';
  public static API_TEACHER_JOIN_REQUEST_API_URL = this.API_BASE_URL + 'get-teacher-join-us';
  public static API_ACCEPT_TEACHER_JOIN_REQUEST_API_URL = this.API_BASE_URL + 'approve-teacher-join-us-request';
  public static API_REJECT_TEACHER_JOIN_REQUEST_API_URL = this.API_BASE_URL + 'reject-teacher-join-us-request';

  // student
  public static GET_STUDENT_QUERY_API_URL = this.API_BASE_URL + 'students-query-by-email-phone';
  public static GET_DEPENDENTS_REQUESTS_API_URL = this.API_BASE_URL + 'get-dependent-requests';
  public static GET_STUDENTS_REQUESTS_API_URL = this.API_BASE_URL + 'get-student-requests';

  // sessions
  public static GET_ALL_SESSIONS_LIST_API_URL = this.API_BASE_URL + 'get-admin-sessions';
  public static UPDATE_SESSION_RECORD_API_URL = this.API_BASE_URL + 'update-session-record';
  public static ADMIN_CHECK_RATED_CALL_API_URL = this.API_BASE_URL + 'admin-check-rated-call';
  public static ADMIN_ADD_SESSION_REVIEW_API_URL = this.API_BASE_URL + 'admin-add-teacher-review';

  // admins
  public static GET_ADMINS_QUERY_API_URL = this.API_BASE_URL + 'query-admin';
  public static ADD_USER_ADMIN_API_URL = this.API_BASE_URL + 'add-user-admin';
  public static UPDATE_ADMIN_PERMISSION_API_URL = this.API_BASE_URL + 'update-admins-permission';
  public static USERS_REPORTS_LIST_API_URL = this.API_BASE_URL + 'get-reportings';
  public static INFORM_REPORTED_USER_API_URL = this.API_BASE_URL + 'inform-reported';
  public static GET_DEPENDENTS_MANAGERS_API_URL = this.API_BASE_URL + 'admin-dependent-managers';
  public static ADMIN_RESPONSE_DEPENDENT_UPGRADE_API_URL = this.API_BASE_URL + 'admin-response-dependent-upgrade';
  public static ADMIN_RESPONSE_STUDENT_UPGRADE_API_URL = this.API_BASE_URL + 'admin-response-student-upgrade';
  public static GET_ADMIN_ACCOUNT_API_URL = this.API_BASE_URL + 'get-admin-account';

  // AWS S3
  public static SIGNED_UPLOAD_MEDIA_API_URL = this.API_BASE_URL + 'get-signed-url';
  public static SIGNED_UPLOAD_FILE_API_URL = this.API_BASE_URL + 'get-admin-signed-url-call-shared-file';

  // lookups
  public static GET_LOOK_UPS_API_URL = this.API_BASE_URL + 'lookups';
  public static ADMIN_GET_RATE_LOOKUPS_API_URL = this.API_BASE_URL + 'admin-get-rate-lookups';
  public static GET_LEARNING_OBJECTIVES_API_URL = this.API_BASE_URL + 'admin/plan-learning-objectives';
  public static GET_ALL_EJAZAT_API_URL = this.API_BASE_URL + 'ejaza-lookup';
  public static GET_SESSION_SLOTS_LOOKUPS_API_URL = this.API_BASE_URL + 'admin/plan-preferred-slots';

  // student management
  public static GET_STUDENTS_LIST_API_URL = this.API_BASE_URL + 'admin-get-studetns';
  public static ADMIN_UPDATE_STUDENT_OPTIONS_API_URL = this.API_BASE_URL + 'admin-update-student-options';
  public static ADMIN_UPDATE_STUDENT_CALL_OPTIONS_API_URL = this.API_BASE_URL + 'admin-update-student-call-options';
  public static ADMIN_RESET_STUDENT_PASSWORD_API_URL = this.API_BASE_URL + 'admin-reset-user-password';
  public static ADMIN_UPDATE_STUDENT_CATEGORIES_API_URL = this.API_BASE_URL + 'update-category-student';
  public static ADMIN_GET_STUDENT_BY_ID_API_URL = this.API_BASE_URL + 'admin-get-student-by-id';
  public static ADMIN_GET_STUDENT_AVAILABLE_PACKAGES_API_URL = this.API_BASE_URL + 'get-student-available-packages';
  public static ADMIN_GET_DEPENDENTS_DURATION_BY_ID_API_URL = this.API_BASE_URL + 'get-dependents-duration-by-id';
  public static ADMIN_ACTIVATE_TEMPORARY_PASSWORD_API_URL = this.API_BASE_URL + 'set-temp-password';
  public static TEACHER_CHANGE_SESSION_PRICE_API_URL = this.API_BASE_URL + 'admin-update-teachers-price';
  public static DELETE_TEACHER_API_URL = this.API_BASE_URL + 'consultant/delete';
  public static ADMIN_GET_DEPENDENTS_API_URL = this.API_BASE_URL + 'students-manger-query';
  public static ADMIN_MOVE_DEPENDENT_API_URL = this.API_BASE_URL + 'change-manger-student';

  // students packages
  public static GET_STUDENTS_PACKAGES_LIST_API_URL = this.API_BASE_URL + 'admin-get-new-student-packages';
  public static ADMIN_UPDATE_PACKAGE_REFUND_REQUEST_API_URL = this.API_BASE_URL + 'refund-package-request';

  //control settings
  public static GENERAL_CONFIGURATIONS_API_URL = this.API_BASE_URL + 'admin-system-config';
  public static ADD_MANUAL_CONFIGURATION_API_URL = this.API_BASE_URL + 'add-manual-package';
  public static UPDATE_CATEGORIES_SETTINGS_API_URL = this.API_BASE_URL + 'update-category';
  public static ADD_CATEGORIES_SETTINGS_API_URL = this.API_BASE_URL + 'add-category';
  public static GET_TEACHER_CATEGORIES_API_URL = this.API_BASE_URL + 'get-teacher-category';
  public static DELETE_TEACHER_CATEGORY_API_URL = this.API_BASE_URL + 'delete-teacher-category';
  public static GET_TEACHER_CATEGORIES_QUERY_API_URL = this.API_BASE_URL + 'teachers-query-sendMessage';
  public static DISCOUNT_CODES_API_URL = this.API_BASE_URL + 'get-global-promoCodes';
  public static DELETE_DISCOUNT_CODE_API_URL = this.API_BASE_URL + 'delete-global-promoCode';
  public static DISCOUNT_CODES_EDIT_CODE_API_URL = this.API_BASE_URL + 'update-global-promoCode';
  public static ADD_DISCOUNT_CODE_API_URL = this.API_BASE_URL + 'add-global-promoCode';
  public static GET_DYNAMIC_LINKS_API_URL = this.API_BASE_URL + 'get-dynamic-links';
  public static ADD_DYNAMIC_LINK_API_URL = this.API_BASE_URL + 'add-dynamic-link';
  public static GET_PEAK_HOURS_API_URL = this.API_BASE_URL + 'query-peak-times';
  public static UPDATE_PEAK_HOURS_API_URL = this.API_BASE_URL + 'update-peak-time';
  public static ADD_PEAK_HOURS_API_URL = this.API_BASE_URL + 'add-peak-time';
  public static GET_ALL_CALL_SHARED_FILES_API_URL = this.API_BASE_URL + 'admin-get-call-shared-files';
  public static DELETE_CALL_SHARED_FILE_API_URL = this.API_BASE_URL + 'delete-call-shared-file';
  public static ADD_CALL_SHARED_FILE_API_URL = this.API_BASE_URL + 'add-call-shared-file';
  public static GET_ALL_FAQ_CATEGORIES_API_URL = this.API_BASE_URL + 'get-all-help-categories';
  public static ADD_FAQ_CATEGORY_API_URL = this.API_BASE_URL + 'add-help-category';
  public static DELETE_FAQ_CATEGORY_API_URL = this.API_BASE_URL + 'delete-help-category';
  public static UPDATE_FAQ_CATEGORY_API_URL = this.API_BASE_URL + 'update-help-category';
  public static GET_ALL_FAQ_API_URL = this.API_BASE_URL + 'get-all-help';
  public static GET_FAQ_BY_ID_API_URL = this.API_BASE_URL + 'get-help-Faq-by-id';
  public static ADD_FAQ_API_URL = this.API_BASE_URL + 'add-help';
  public static UPDATE_FAQ_API_URL = this.API_BASE_URL + 'update-help';
  public static DELETE_FAQ_API_URL = this.API_BASE_URL + 'delete-help';
  public static GET_SCHEDULED_NOTIFICATIONS_API_URL = this.API_BASE_URL + 'get-scheduled-notifications';
  public static REMOVE_SCHEDULED_NOTIFICATIONS_API_URL = this.API_BASE_URL + 'remove-scheduled-notifications';

  //Free-Codes:
  public static FREE_CODES_API_URL = this.API_BASE_URL + 'get-free-Codes';
  public static DELETE_FREE_CODE_API_URL = this.API_BASE_URL + 'delete-free-code';
  public static EDIT_FREE_CODE_API_URL = this.API_BASE_URL + 'update-free-code';
  public static CREATE_FREE_CODE_API_URL = this.API_BASE_URL + 'create-free-code';

  //Ads:
  public static ADS_API_URL = this.API_BASE_URL + 'get-admin-banners';
  public static DELETE_ADS_API_URL = this.API_BASE_URL + 'delete-admin-banner';
  public static GET_CATEGORIES_ADS_API_URL = this.API_BASE_URL + 'get-categorise-with-teachers';
  public static GET_SIGNED_API_URL = this.API_BASE_URL + 'get-signed-url';
  public static SET_ADMIN_BANNER_API_URL = this.API_BASE_URL + 'set-admin-banner';
  public static UPDATE_ADMIN_BANNER_API_URL = this.API_BASE_URL + 'update-admin-banner';

  //marketplace
  public static GET_ALL_PACKAGES_API_URL = this.API_BASE_URL + 'get-all-packages-with-promoCodes';
  public static GET_PACKAGE_API_URL = this.API_BASE_URL + 'get-package-with-promoCodes';
  public static GET_PROMOCODES_PACKAGE_API_URL = this.API_BASE_URL + 'get-package-promo-codes';
  public static UPDATE_PACKAGE_API_URL = this.API_BASE_URL + 'update-package';
  public static ADD_PACKAGE_API_URL = this.API_BASE_URL + 'add-new-package-with-promoCode';
  public static EDIT_PACKAGE_DISCOUNT_CODE_API_URL = this.API_BASE_URL + 'edit-promo-code';
  public static ADD_PACKAGE_DISCOUNT_CODE_API_URL = this.API_BASE_URL + 'add-promo-code';
  public static DELETE_PACKAGE_API_URL = this.API_BASE_URL + 'delete-package';
  public static DELETE_PROMO_CODE_API_URL = this.API_BASE_URL + 'delete-promo-code';
  public static GET_MARKETPLACE_PRODUCTS_API_URL = this.API_BASE_URL + 'get-products-for-dashboard';
  public static HIDE_MARKETPLACE_PRODUCT_API_URL = this.API_BASE_URL + 'hide-product';
  public static UPDATE_MARKETPLACE_PRODUCT_API_URL = this.API_BASE_URL + 'update-product';
  public static ADD_MARKETPLACE_PRODUCT_API_URL = this.API_BASE_URL + 'add-product';
  public static DELETE_MARKETPLACE_PRODUCT_API_URL = this.API_BASE_URL + 'delete-product';

  // user profile
  public static UPDATE_USER_INFO_API_URL = this.API_BASE_URL + 'update-user-admin';

  // send msg
  public static SEND_MESSAGE_API_URL = this.API_BASE_URL + 'send-notification-dashboard';
  public static NEW_SEND_MESSAGE_API_URL = this.API_BASE_URL + 'send-notification-dashboard-v2';

  //uploads
  public static UPLOAD_TEACHERS_FILE_API_URL = this.API_BASE_URL + 'admin-add-teachers';
  public static UPLOAD_STUDENTS_FILE_API_URL = this.API_BASE_URL + 'admin-add-students';
  public static UPLOAD_STUDENTS_UPDATE_FILE_API_URL = this.API_BASE_URL + 'admin-update-students';
  public static UPLOAD_STUDENTS_PLANS_FILE_API_URL = this.API_BASE_URL + 'admin-add-students-plans';

  //beneficiaries
  public static GET_DASHBOARD_BENEFICIARIES = this.API_BASE_URL + 'get-beneficiaries-for-dashboard';
  public static ADD_BENEFICARY = this.API_BASE_URL + 'add-beneficiary';
  public static UPDATE_BENEFICARY = this.API_BASE_URL + 'update-beneficiary';
  public static DELETE_BENEFICARY = this.API_BASE_URL + 'delete-beneficiary';
  public static ADMIN_UPDATE_STUDENT_BALANCE_API_URL = this.API_BASE_URL + 'admin-update-student-balance';

  //receivables
  public static GET_REFUND_REQUESTS_API_URL = this.API_BASE_URL + 'get-refund-requests';

  //dependents management
  public static ADD_BALANCE_FOR_DEPENDENT_API_URL = this.API_BASE_URL + 'add-balance';
  public static DELETE_DEPENDENT_API_URL = this.API_BASE_URL + 'delete-dependents';
  public static RESTORE_DEPENDENT_BALANCE_API_URL = this.API_BASE_URL + 'admin-get-balance';
  public static ADD_DEPENDENT_API_URL = this.API_BASE_URL + 'create-dependent-by-admin';
  public static EDIT_DEPENDENT_API_URL = this.API_BASE_URL + 'update-dependent-by-admin';

  //exported reports
  public static GET_EXPORTED_REPORTS_API_URL = this.API_BASE_URL + 'get-exported-reports';

  //query send message
  public static GET_STUDENTS_QUERY_API_URL = this.API_BASE_URL + 'students-query-sendMessage';
  public static GET_TEACHERS_QUERY_API_URL = this.API_BASE_URL + 'teachers-query-sendMessage';

  //query add teacher
  public static GET_EJAZA_QUERY_API_URL = this.API_BASE_URL + 'query-ejaza';
  public static ADMIN_ADD_TEACHER_API_URL = this.API_BASE_URL + 'admin-add-teachers';
  public static ADMIN_UPDATE_TEACHER_API_URL = this.API_BASE_URL + 'admin-update-teachers';

  public static GET_INSOLVENTS_QUERY_API_URL = this.API_BASE_URL + 'get-insolvant-requests';
  public static ADD_INSOLVENT_CODE_API_URL = this.API_BASE_URL + 'add-code-to-insolvant';

  // white label dashboard
  public static GET_QURAN_ENTHUSIASTS_STATISTICS_API_URL =
    this.API_BASE_URL + 'application-quran-enthusiasts-statistics';
  public static GET_APPLICATION_TOTAL_SESSIONS_API_URL = this.API_BASE_URL + 'application-total-session-statistics';
  public static GET_APPLICATION_LATEST_COMMENTS_API_URL = this.API_BASE_URL + 'application-latest-reviews-statistics';
  public static GET_APPLICATION_CHART_STATISTICS_API_URL = this.API_BASE_URL + 'application-statistics-chart';
  public static GET_APPLICATION_MAP_STATISTICS = this.API_BASE_URL + 'application-map-statistics';
  public static GET_WL_PDF_GENDER_COUNT = this.API_BASE_URL + 'application-statistics-chart-pdf';

  // fetch countries map json
  public static COUNTRIES_MAP_JSON_API = 'https://unpkg.com/world-atlas/countries-50m';

  //notifications
  public static GET_LATEST_NOTIFICATIONS_API_URL = this.API_BASE_URL + 'admin/latest-notifications';
  public static GET_UNSEEN_NOTIFICATIONS_COUNT_API_URL = this.API_BASE_URL + 'admin/unseen-notification-count';
  public static MARK_NOTIFICATION_AS_READ_API_URL = this.API_BASE_URL + 'admin/mark-notification-read';
  public static UPDATE_NOTIFICATION_TOKEN_API_URL = this.API_BASE_URL + 'admin/update-configuration';

  //fatiha requests
  public static GET_FATIHA_REQUESTS_API_URL = this.API_BASE_URL + 'fatiha/admin/pending-extra-sessions';
  public static ACCEPT_FATIHA_REQUEST_API_URL = this.API_BASE_URL + 'fatiha/admin/extra-session/action';

  // consultant
  public static GET_CONSULTANT_BALANCE_API_URL = this.API_BASE_URL + 'consultant/dues';
  public static GET_CONSULTANT_PAID_BALANCE_API_URL = this.API_BASE_URL + 'consultant/paid-dues';
}
